module.exports = __webpack_public_path__ + "img/share-weibo.609b08a0.png";